import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { HotelCardContext } from 'components/HotelCardContext';
import { PriceWatchCTAWrapper } from 'components/PriceWatchCTAWrapper/PriceWatchCTAWrapper';
import { getAnchorComplete, getHotel } from 'modules/sapiSearch/selectors';
import { toggle } from 'opticks';
import { Box } from '@daedalus/atlas/helpers/Box';
import { PriceWatchBell } from '@daedalus/shared/src/priceWatch/components/PriceWatchBell';
import { PriceWatchToggle } from '@daedalus/shared/src/priceWatch/components/PriceWatchToggle/PriceWatchToggle';
const GALLERY_WIDTH_DESKTOP = 278;
const TOP_OFFER_WIDTH_DESKTOP = 232;
const MIN_CARD_INNER_HEIGHT = 237;
export const MIN_COMPACT_CARD_INNER_HEIGHT = 146;
interface Props {
  /** If the hotel is the anchor hotel */
  isAnchor?: boolean;

  /** The component to render for the gallery */
  galleryComponent: React.ReactNode;

  /** The component to render for the property summary */
  propertySummaryComponent: React.ReactNode;

  /** The component to render for the offer list */
  offerListComponent: React.ReactNode;

  /** The component to render for the top offer */
  topOfferComponent: React.ReactNode;

  /** The component to render for the availability pane */
  availabilityPaneComponent: React.ReactNode;
}

// TODO:[Search] -  Add border-left property to Box
const _exp = /*#__PURE__*/() => Box;
const TopOfferWrapper = /*#__PURE__*/styled(_exp())({
  name: "TopOfferWrapper",
  class: "t1na1yud",
  propsAsIs: true
});
const PriceWatchWrapper = /*#__PURE__*/styled('div')({
  name: "PriceWatchWrapper",
  class: "p1lx97wr",
  propsAsIs: false
});

/**
 * The base skeleton of the hotel card
 */
export const BaseHotelCard: React.FC<Props> = ({
  isAnchor = false,
  galleryComponent,
  propertySummaryComponent,
  offerListComponent,
  topOfferComponent,
  availabilityPaneComponent
}) => {
  const {
    isHotelDetailsOverlay,
    hotelId
  } = useContext(HotelCardContext);
  const hotel = useSelector(state => getHotel(state, hotelId));
  const anchorComplete = useSelector(getAnchorComplete);
  const shouldShowPriceWatchToggle = isAnchor && !isHotelDetailsOverlay && anchorComplete;
  return <Box padding={isHotelDetailsOverlay ? 's000' : 's400'} borderRadius="xxl" marginTop={isAnchor && !isHotelDetailsOverlay ? 's200' : 's000'} borderStyle="solid" borderWidth="s100" borderColor={isAnchor && !isHotelDetailsOverlay ? 'hotelCard.special.border' : 'border.neutral.c000'}>
      <Box minHeight={`${MIN_CARD_INNER_HEIGHT}px`} display="grid" gridAutoFlow="column" gridAutoRows="1fr auto" gridTemplateColumns={`${GALLERY_WIDTH_DESKTOP}px 1fr ${TOP_OFFER_WIDTH_DESKTOP}px`} position="relative">
        <Box height="100%" gridColumn="1 / 2" gridRow="1 / 3">
          {galleryComponent}
        </Box>
        <Box display="flex" flexDirection="column" height="100%" gridColumn="2 / 3" gridRow="1 / 2" overflow="hidden">
          <Box height="100%" paddingLeft="s500" paddingRight="s500" marginBottom={toggle('70766997-desktop-hotel-card-secondary-offers', 's000', 's400')}>
            {propertySummaryComponent}
          </Box>
          <div>{offerListComponent}</div>
        </Box>
        <TopOfferWrapper display="flex" flexDirection="row" height="100%" grid-column="3 / 4" gridRow="1 / 2" className={cx(!availabilityPaneComponent && '__leftBorder')}>
          {topOfferComponent}
        </TopOfferWrapper>
        {availabilityPaneComponent}
        <Box position="absolute" left="12px" top="12px" zIndex="1">
          <PriceWatchCTAWrapper hotel={hotel} ctaComponent={PriceWatchBell} componentName="PriceWatchBell" holdOutElement={null} searchIsCompleted />
        </Box>
      </Box>

      {shouldShowPriceWatchToggle && <PriceWatchWrapper>
          <PriceWatchCTAWrapper hotel={hotel} shouldPulse={false} ctaComponent={PriceWatchToggle} componentName="PriceWatchToggle" holdOutElement={null} searchIsCompleted />
        </PriceWatchWrapper>}
    </Box>;
};

require("./index.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");